import { ListResult } from '../../ts/fetchers/ListResult';
import { ISliceable } from '../../ts/models/ISliceable';
import { BaseParamsBuilderResourceQuery } from '../../ts/resources/ResourceQuery';
import { ItemWithId } from './GraphQLSliceable';

/**
 * This is a base class for all GraphQL resource queries. We use a base class so the fetching logic
 * can easily distinguish between traditional and GraphQL resources.
 */
export abstract class BaseGraphQLResourceQuery<TResultItem extends ItemWithId>
extends BaseParamsBuilderResourceQuery<TResultItem> {

  constructor() {
    super();
  }

  protected abstract makeSliceable(): ISliceable<TResultItem>;

  public getSlice(start: number, size: number): Promise<ListResult<TResultItem>> {
    const sliceable = this.makeSliceable();
    return sliceable.getSlice(start, size);
  }

  public getCount(): Promise<number> {
    // There are certainly cleverer ways to get this data than by making another query.
    // But that would be premature optimization.
    const sliceable = this.makeSliceable();
    return sliceable.getSlice(0, 0)
      .then(listResult => listResult.total)
      .catch((reason: any) => {
        // Ignore errors because the service can be down.
        // We don't need to report to the user when getting counts fails, that's annoying.
        return 0;
      });
  }

  public getFirst(): Promise<TResultItem> {
    throw new Error('getFirst is not used for GraphQL resource queries. Implement it later if we need to!');
  }
}
